import type { FilterUnion } from "~/@types/utility-types";
import type { G_GetVideoQuery } from "~/lib/graphql";

export type VideoSeasonType = FilterUnion<G_GetVideoQuery["video"], "__typename", "VideoSeason">;
export type VideoLegacySeasonType = FilterUnion<G_GetVideoQuery["video"], "__typename", "VideoLegacySeason">;
export type VideoStageSeasonType = FilterUnion<G_GetVideoQuery["video"], "__typename", "VideoStageSeason">;
export type VideoSpotLiveSeasonType = FilterUnion<G_GetVideoQuery["video"], "__typename", "VideoSpotLiveSeason">;

export const isVideoSeason = (video: G_GetVideoQuery["video"]): video is VideoSeasonType => {
  return video.__typename === "VideoSeason";
};

export const isVideoLegacySeason = (video: G_GetVideoQuery["video"]): video is VideoLegacySeasonType => {
  return video.__typename === "VideoLegacySeason";
};

export const isVideoStageSeason = (video: G_GetVideoQuery["video"]): video is VideoStageSeasonType => {
  return video.__typename === "VideoStageSeason";
};

export const isVideoSpotLiveSeason = (video: G_GetVideoQuery["video"]): video is VideoSpotLiveSeasonType => {
  return video.__typename === "VideoSpotLiveSeason";
};
